/*
 * argile-load-more.js — bouton « Voir la suite ».
 * Charge la page suivante en AJAX, ajoute ses produits à la grille, met à jour
 * le compteur (« X teintes affichées sur Y ») et l'URL du bouton (ou le retire
 * quand il n'y a plus de page). Délégation au document (le bouton est re-rendu
 * par le natif après un filtre AJAX).
 */
(() => {
  let loading = false;

  document.addEventListener('click', async (event) => {
    const btn =
      event.target.closest && event.target.closest('[data-load-more-url]');
    if (!btn || loading) return;
    event.preventDefault();

    loading = true;
    btn.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(btn.getAttribute('data-load-more-url'));
      const doc = new DOMParser().parseFromString(
        await response.text(),
        'text/html'
      );

      const grid = document.querySelector('.product-grid');
      if (grid) {
        doc
          .querySelectorAll('.product-grid .product-grid__item')
          .forEach((item) => grid.appendChild(item));
      }

      // URL de page suivante (ou retrait du bouton si dernière page).
      const next = doc.querySelector('[data-load-more-url]');
      if (next) {
        btn.setAttribute(
          'data-load-more-url',
          next.getAttribute('data-load-more-url')
        );
        btn.setAttribute('href', next.getAttribute('href'));
      } else {
        btn.remove();
      }

      // Compteur = nombre de produits désormais chargés.
      const shownEl = document.querySelector('[data-load-more-shown]');
      if (shownEl) {
        shownEl.textContent = document.querySelectorAll(
          '.product-grid .product-grid__item'
        ).length;
      }
    } finally {
      loading = false;
      btn.removeAttribute('aria-busy');
    }
  });
})();
